export default {
    approved: 'APPROVED',
    control: 'CONTROL',
    rejected: 'REJECTED',
    documentsSent: 'DOCUMENTS_SENT',
    newCase: 'NEW_CASE',
    documentsComplete: 'DOCUMENTS_COMPLETE',
};
